import RouteNames from './RouteNames'
import type { AppRoutes, AppRouteToName } from './types'

// Routes that are served from www.betterplace.org instead of secure.betterplace.org
const servedFromWWW = new Set<AppRouteToName<AppRoutes>>([
  RouteNames.donate,
  RouteNames.donateSuccess,
  RouteNames.donateSuccessDirectDeposit,
  RouteNames.donateIframeSuccess,
  RouteNames.fundraisingEvents,
  RouteNames.fundraisingEventsSharingOptions,
  RouteNames.fundraisingEventsManageProjects,
  RouteNames.apiFundraisingEventImage,
  RouteNames.apiFundraisingEventAdminBox,
  RouteNames.apiFundraisingEventDonationFeed,
  RouteNames.apiFundraisingEventDonationList,
  RouteNames.apiFundraisingEventDonationFeedHistory,
])

export default servedFromWWW
